import Header from "./Header";
import Footer from "./Footer";

interface LayoutProps {
  children: React.ReactNode;
  headerTransparent?: boolean;
}

const Layout = ({ children, headerTransparent = false }: LayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header transparent={headerTransparent} />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
